import { Country, LearningObjectiveType, Year } from '@types';
import { gradeOptions } from './programme-options';

export const getFiltersMap = (
    loType: LearningObjectiveType,
    yearsMap: Record<LearningObjectiveType, { id: string; name: string }[]>,
    years: Year[],
) => {
    return {
        [Country.GB]: {
            title: {
                type: 'input',
                label: 'Title',
                options: [],
            },
            id: {
                type: 'input',
                label: 'ID',
                options: [],
            },
            objective_type: {
                type: 'select',
                label: 'Type',
                options: [
                    { id: 'standard', name: 'Standard' },
                    { id: 'sats', name: 'SATs' },
                    { id: 'gcse', name: 'GCSEs' },
                ],
                resetFields: { year_id: '' },
            },
            year_id: {
                type: 'select',
                label: 'Year',
                options: yearsMap[loType] || years,
                multiple: true,
                placeholder: 'Year',
            },
            active: {
                type: 'select',
                label: 'Active',
                options: [
                    { id: 'active', name: 'Active' },
                    { id: 'inactive', name: 'Inactive' },
                ],
                transformValue: (value: string) => {
                    if (value === 'active') return true;
                    if (value === 'inactive') return false;
                    return '';
                },
            },
        },
        [Country.US]: {
            title: {
                type: 'input',
                label: 'Title',
                options: [],
            },
            id: {
                type: 'input',
                label: 'ID',
                options: [],
            },
            year_id: {
                type: 'select',
                label: 'Grade',
                options: gradeOptions,
                multiple: true,
                placeholder: 'Grade',
            },
            active: {
                type: 'select',
                label: 'Active',
                options: [
                    { id: 'active', name: 'Active' },
                    { id: 'inactive', name: 'Inactive' },
                ],
                transformValue: (value: string) => {
                    if (value === 'active') return true;
                    if (value === 'inactive') return false;
                    return '';
                },
            },
        },
    };
};
